// Firebase
import {
  auth, db, actionCode, functions, firestore,
} from '@/shared/services/firebase'
import axios from '@hw-core/libs/axios'

export default {
  namespaced: true,
  state: {
    authUser: null,
    accounts: [],
    selectedAccount: null,
  },
  getters: {
    /*
    const isAuthenticated = auth().currentUser // get firebase current user
    return localStorage.getItem('userInfo') && isAuthenticated
    */
    isLoggedIn: state => [auth.currentUser, state.authUser].indexOf(null) === -1
  },
  mutations: {
    SET_USER(state, user) {
      state.authUser = user
    },
    SET_ACCOUNTS(state, accounts) {
      state.accounts = accounts
    },
    SET_ACCOUNT(state, account) {
      state.selectedAccount = account
    },
  },
  actions: {
    login(ctx, queryParams) { // authentication - this is call when user clicks on "log in" page on "pages/login"
      return new Promise((resolve, reject) => {
        auth.signInWithEmailAndPassword(queryParams.email, queryParams.password).then(async result => {
          const userDoc = await db.collection('users').doc(result.user.uid).get()
          const user = {
            ...userDoc.data(),
            id: userDoc.id,
          }
          ctx.dispatch('setCurrentUser', user)
          resolve(user)
        }).catch(() => {
          reject()
        })
      })
    },

    sendEmailSignIn(ctx, form) {
      return new Promise((resolve, reject) => {
        auth.sendSignInLinkToEmail(form.email, actionCode).then(() => {
          localStorage.setItem('hoiwaApplyData', JSON.stringify(form))
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },

    isSignInWithEmailLink() {
      return new Promise(resolve => {
        if (auth.isSignInWithEmailLink(window.location.href)) {
          const formData = JSON.parse(localStorage.getItem('hoiwaApplyData'))
          resolve(formData)
        } else {
          resolve(false)
        }
      })
    },

    isEmailTaken(ctx, email) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/checkIfEmailExists`, { email })
          .then(response => resolve(response.data.result))
          .catch(error => reject(error))
      })
    },

    sendOTP(ctx, email) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/sendOTP`, { email },
            {
              validateStatus: status => status === 200,
            })
          .then(() => resolve())
          .catch(error => reject(error))
      })
    },

    verifyOTP(ctx, { email, OTP }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/verifyOTP`, { email, OTP },
            {
              validateStatus: status => status === 200,
            })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },

    createOneTimeCredentials(ctx, { email, OTP }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/createOneTimeCredentials`, { email, OTP },
            {
              validateStatus: status => status === 200,
            })
          .then(response => resolve(response.data.secret))
          .catch(error => reject(error))
      })
    },

    createNewUser(ctx, { user, otp, password }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/createNewUser`, { user, otp, password })
          .then(response => resolve(response))
          .catch(() => reject())
      })
    },

    deactivateOTP(ctx, { email, OTP }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/deactivateOTP`, { email, OTP },
            {
              validateStatus: status => status === 200,
            })
          .then(() => resolve())
          .catch(error => reject(error))
      })
    },

    signIn(ctx, { email, password }) { // TODO currently unused, possible duplicated
      return new Promise((resolve, reject) => {
        auth.signInWithEmailAndPassword(email, password).then(result => {
          resolve(result.user.uid)
        }).catch(() => {
          reject()
        })
      })
    },

    signInWithEmail(ctx, email) {
      return new Promise((resolve, reject) => {
        auth.signInWithEmailLink(email, window.location.href)
          .then(result => {
            resolve(result)
          }).catch(() => {
            reject()
          })
      })
    },
    async logout(ctx) {
      await auth.signOut()
      ctx.dispatch('setCurrentUser', null)
    },
    fetchAndSetUserData(ctx, uid) {
      return new Promise((resolve, reject) => {
        db.collection('users').doc(uid).get()
          .then(async result => {
            const user = { ...result.data(), id: uid }
            ctx.dispatch('setCurrentUser', user)
            resolve(user)
          })
          .catch(() => {
            reject()
          })
      })
    },
    setSelectedAccount(ctx, account) {
      ctx.dispatch('setAccount', account)
    },
    getCurrentUser(ctx) {
      return new Promise((resolve, reject) => {
        if (ctx.state.authUser) {
          resolve(ctx.state.authUser)
        }
        reject()
      })
    },

    setCurrentUser(ctx, user) {
      ctx.commit('SET_USER', user)
    },
    setAccounts(ctx, accounts) {
      return new Promise(resolve => {
        ctx.commit('SET_ACCOUNTS', accounts)
        resolve()
      })
    },
    setAccount(ctx, account) {
      return new Promise(resolve => {
        ctx.commit('SET_ACCOUNT', account)
        resolve()
      })
    },
    createApplication(ctx, { user, OTP }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/applyCreateUser`, { user, OTP },
            {
              validateStatus: status => status === 200,
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async getAllEmployees(ctx, { query }) {
      const usersCollection = await firestore()
        .collection('users')
        .where('fullName', '>=', query)
        .where('fullName', '<=', `${query}\uf8ff`)
        .limit(10)
        .get()
      const users = usersCollection.docs.map(item => ({
        label: item.data().fullName,
        value: { name: item.data().fullName, id: item.id, confirmed: item.data().confirmed, profession: item.data().profession, love: item.data().love },
      })).filter(user => user.value.confirmed).sort((a, b) => (a.label > b.label ? 1 : -1))

      return users
    },
    async getEmployee(ctx, data) {
      const userDoc = await firestore().collection('users').doc(data.query).get()
      return userDoc.data().fullName
    },
    async fetchAreas(ctx, {accountId}) {
      const areasCollection = await firestore().collection('areas').where('accountId', '==', accountId).get()
      const areas = areasCollection.docs.map(item => ({
        label: item.data().name,
        value: item.id,
      }))
      return areas
    },
    async fetchContract(ctx, {contractId}) {
      const contractDoc = await firestore()
        .collection('contracts')
        .doc(contractId)
        .get()
      return {
        ...contractDoc.data(),
        id: contractDoc.id,
      }
    },
  },
}
